"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _system = require("@mui/system");
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _SocialMediaIconGroup = _interopRequireDefault(require("../../molecules/SocialMediaIconGroup/SocialMediaIconGroup"));
var _FooterSubscribeForm = _interopRequireDefault(require("../../molecules/FooterSubscribeForm/FooterSubscribeForm"));
var _GridTwo = _interopRequireDefault(require("../../components/Grid/GridTwo/GridTwo"));
var _material = require("@mui/material");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledLink = (0, _styledComponents.default)(_Link.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: var(--bf-dark-grey) !important;\n"])));
var LinkTextGroup = (0, _styledComponents.default)(function (_ref) {
  var props = _ref.props;
  return _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center"
  }, props), _react.default.createElement(_Paragraph.default, {
    psmall: true
  }, "\xA9 2024 BestFit | All Rights Reserved | ", _react.default.createElement(StyledLink, {
    href: "/privacy-policy",
    target: "_blank",
    title: "Privacy Policy"
  }, "Privacy Policy"), " | ", _react.default.createElement(StyledLink, {
    href: "/terms-conditions",
    target: "_blank",
    title: "Terms & Conditions"
  }, " Terms & Conditions")));
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var FooterBoxStyles = (0, _styledComponents.default)(_system.Box)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 16.25px; \n  padding-top: 16.25px;\n  background-image: url(", ");\n  background-color: ", ";\n  \n  @media (min-width: ", ") {\n    padding-bottom: 32.5px; \n    padding-top: 32.5px;\n  }\n"])), function (props) {
  return props.backgroundImageUrl;
}, function (props) {
  return props.heroBackgroundColor;
}, _bfBaseStyles.Breakpoints.m);
var FooterEmbed = _styledComponents.default.iframe(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  border: 0;\n  background-color: transparent;\n  width: 250px !important;\n  height: 250px !important;\n\n  iframe {\n    overflow: hidden !important;\n  }\n    \n  @media (min-width: ", ") {\n    width: 350px !important;\n    height: 180px !important;\n  }\n"])), _bfBaseStyles.Breakpoints.xs);
var Footer = function Footer(_ref2) {
  var props = _ref2.props;
  return _react.default.createElement(FooterBoxStyles, Object.assign({
    heroBackgroundColor: 'var(--bf-core-yellow)',
    justifyContent: "space-between"
  }, props), _react.default.createElement(_material.Container, {
    maxWidth: "lg"
  }, _react.default.createElement(_Grid.default, {
    container: true,
    maxWidth: 'xl',
    justifyContent: "center",
    display: "flex",
    alignItems: "center"
  }, _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 6,
    md: 5,
    lg: 5,
    display: "flex"
  }, _react.default.createElement(FooterEmbed, {
    src: "https://bestfit.formstack.com/forms/newsletter_sign_up",
    title: "Newsletter sign up",
    width: "325",
    height: "200"
  })), _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 5,
    md: 3,
    lg: 3,
    container: true,
    mdOffset: 'auto',
    alignItems: "flex-start",
    style: {
      height: '100%'
    }
  }, _react.default.createElement(_material.Stack, {
    spacing: 8,
    direction: "column",
    justifyContent: "space-between"
  }, _react.default.createElement(_SocialMediaIconGroup.default, null), _react.default.createElement(LinkTextGroup, null))))));
};
var _default = Footer;
exports.default = _default;